import { LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { DownloadPDF } from "@/helper/downloadPdfHelper";
import { i18n } from "@/i18n";
import { DocumentGeneratePdfModel } from "@/model/document/documentModel";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { MappingContentPdf, ConvertHtmlToCanvas, AddCanvasesToPDF, ConvertDocToBase64String, GetParamsForPDFLogService } from "../../helper/generatePdfHelper";
import service from "../../../src/service/baseHttpService";
import { SetHeaderService } from "@/helper/authenticationHelper";

@Module({ namespaced: true })
export default class GeneratePdf extends VuexModule {
  private generatePdfLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private showModalGeneratePdf: boolean = false;
    
  get getGeneratePdfLoadingStatus(): LoadingStatusType {
    return this.generatePdfLoadingStatus;
  }
  get getShowModalGeneratePdf(): boolean {
    return this.showModalGeneratePdf;
  }

  @Mutation
  public MutationGeneratePdfLoadingStatus(loadingStatus: LoadingStatusType) {
     this.generatePdfLoadingStatus = loadingStatus;
  }
  
  @Mutation
  public MutationShowModalGeneratePdf(showModal: boolean) {
    this.showModalGeneratePdf = showModal;
  }

  @Action
  public DoGeneratePdf(input: DocumentGeneratePdfModel) {
    if (this.generatePdfLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGeneratePdfLoadingStatus", LoadingStatusType.Loading);
      let idNoificition = new Date().getTime();
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          id: idNoificition,
          typeUpload: "Start",
          typeMessage: TypeComponentNoti.Download,
        },
        { root: true }
      );

      API.GeneratePdfService.DoGenPdfFromUrl(input.passCode).then((res: any) => {
        let genSuccess = false;
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.base64Str) {
            const fileName = input.transactionNumber;
            DownloadPDF(res.data.base64Str, fileName);
            genSuccess = true;
          } else {
            genSuccess = false;
          }
        } else {
          genSuccess = false;
        }
        if (genSuccess) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              id: idNoificition,
              typeUpload: "End",
              alertMessage: i18n.t("Alert_Create_Document_Success", {
                name: (input.isDocumentNameShort ? " " : "") + input.documentName,
                number: input.transactionNumber,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          this.context.commit('MutationShowModalGeneratePdf', true)
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              id: idNoificition,
              typeUpload: "End",
              alertMessage: i18n.t("Alert_Create_Document_Failed"),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationGeneratePdfLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public async DoGeneratePdfClientSide(input: DocumentGeneratePdfModel) {
    const idNoificition: number = new Date().getTime();
    const { contents, paperSize, paperOrientation, paperClassName } = await MappingContentPdf(input.transactionType);

    try {
      this.context.dispatch("DoGeneratePdfLogService", input);
      this.context.commit("MutationGeneratePdfLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          id: idNoificition,
          typeUpload: "Start",
          typeMessage: TypeComponentNoti.Download,
        },
        { root: true }
      );

      let doc = new jsPDF(paperOrientation, "mm", `${paperSize}`, true);
      const width: number = doc.internal.pageSize.getWidth();
      const height: number = doc.internal.pageSize.getHeight();
      const canvases = await ConvertHtmlToCanvas(contents, paperClassName)
      AddCanvasesToPDF(canvases, doc, width, height, input);
      doc.save(`${input.transactionNumber}.pdf`);
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          id: idNoificition,
          typeUpload: "End",
          alertMessage: i18n.t("Alert_Create_Document_Success", {
            name: (input.isDocumentNameShort ? " " : "") + input.documentName,
            number: input.transactionNumber,
          }),
          typeMessage: TypeComponentNoti.Success,
        },
        { root: true }
      );
    } catch (error) {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          id: idNoificition,
          typeUpload: "End",
          alertMessage: i18n.t("Alert_Create_Document_Failed"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    } finally {
      this.context.commit("" +
          "", LoadingStatusType.Success);
    }
  }
  @Action
  public async DoGeneratePdfLogService(input: DocumentGeneratePdfModel) {
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.get("efti")){
      return
    }
    const { contents, paperSize, paperOrientation, paperClassName } =
      await MappingContentPdf(input.transactionType);
    try {
      const doc = new jsPDF(paperOrientation, "mm", `${paperSize}`, true);
      const width: number = doc.internal.pageSize.getWidth();
      const height: number = doc.internal.pageSize.getHeight();
      const canvases = await ConvertHtmlToCanvas(contents, paperClassName)
      AddCanvasesToPDF(canvases, doc, width, height, input);
      const base64StringWithoutTag = await ConvertDocToBase64String(doc);
      const params = GetParamsForPDFLogService(urlParams, base64StringWithoutTag)
      service.peakPDFLog.post(
        "/PdfLog/CheckOnlineViewLastest",
        params,
        SetHeaderService()
      );
    } finally {}
  }
  
  @Action
    public DoUpdateShowModalGeneratePdf(showModal: boolean) {
      this.context.commit("MutationShowModalGeneratePdf", showModal);
    }
}
